import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveZone } from '../../shared/components';
import { useGetZone } from '@/shared/actions/erp';

export type UpdateZonePageProps = {};

const UpdateZonePage: React.FC<UpdateZonePageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_zona);
  const returnUrlZonesPage =
  ROUTER_PATHS.mantenimientoOperaciones.zonasNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetZone(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_zona) return <Navigate to={returnUrlZonesPage} />;

  return <SaveZone titlePage="Editar Zona" editZone={data.data} />;
};

export default UpdateZonePage;